module.exports = __webpack_public_path__ + "img/alcoholera.ccd5862d.jpg";